import { Select as SelectPrimitive } from "@base-ui/react/select"
import PropTypes from "prop-types"
import React from "react"

import {
  Select,
  SelectContent,
  SelectTrigger,
  SelectValue,
} from "src/components/Select"

const CLEAR_VALUE = ""

const CellSelectOption = ({ children, value }) => (
  <SelectPrimitive.Item
    value={value}
    className="flex cursor-default items-center px-3 py-2 text-sm outline-none hover:bg-gray-100 data-[highlighted]:bg-gray-100"
  >
    <SelectPrimitive.ItemText>{children}</SelectPrimitive.ItemText>
  </SelectPrimitive.Item>
)

CellSelectOption.propTypes = {
  children: PropTypes.node.isRequired,
  value: PropTypes.string.isRequired,
}

const CellSelect = ({
  children,
  value = null,
  label,
  placeholder = "Select...",
  clearLabel = "Clear selection",
  onChange,
  disabled = false,
}) => {
  const handleValueChange = (newValue) => {
    onChange(newValue === CLEAR_VALUE ? null : newValue)
  }

  return (
    <Select
      value={value ?? CLEAR_VALUE}
      onValueChange={handleValueChange}
      disabled={disabled}
    >
      <SelectTrigger variant="cell">
        <SelectValue>
          {label ?? <span className="text-gray-600">{placeholder}</span>}
        </SelectValue>
      </SelectTrigger>
      <SelectContent>
        <SelectPrimitive.Item
          value={CLEAR_VALUE}
          className="flex cursor-default items-center px-3 py-2 text-sm text-gray-500 outline-none hover:bg-gray-100 data-[highlighted]:bg-gray-100"
        >
          <SelectPrimitive.ItemText>{clearLabel}</SelectPrimitive.ItemText>
        </SelectPrimitive.Item>
        {children}
      </SelectContent>
    </Select>
  )
}

CellSelect.propTypes = {
  children: PropTypes.node,
  value: PropTypes.string,
  label: PropTypes.node,
  placeholder: PropTypes.string,
  clearLabel: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
}

CellSelect.Option = CellSelectOption

export default CellSelect
